import useApi from '../hooks/useApi';

let cachedPayload = null;
let cachedAtMs = 0;
let inflightRequest = null;

const CACHE_TTL_MS = 30000;

export function clearPremiumMigrationInfoCache() {
  cachedPayload = null;
  cachedAtMs = 0;
  inflightRequest = null;
}

export async function getPremiumMigrationInfo(options = {}) {
  const { forceRefresh = false } = options;
  const now = Date.now();

  if (!forceRefresh && cachedPayload && now - cachedAtMs < CACHE_TTL_MS) {
    return cachedPayload;
  }

  if (!forceRefresh && inflightRequest) {
    return inflightRequest;
  }

  inflightRequest = (async () => {
    const response = await useApi('PREMIUM_MIGRATION_INFO', {}, {}, ['_Id']);
    const payload = response?.details || response || {};
    cachedPayload = payload;
    cachedAtMs = Date.now();
    return payload;
  })();

  try {
    return await inflightRequest;
  } finally {
    inflightRequest = null;
  }
}
